var _path, _rect, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.414 2H6C4.897 2 4 2.898 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V6.586L15.414 2ZM7 12H15V14H7V12ZM17 18H7V16H17V18ZM14 8V3L19 8H14Z",
    fill: "#C90000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 12,
    height: 8,
    fill: "#C90000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41615 18V14.3636H8.8508C9.12661 14.3636 9.36158 14.4163 9.55571 14.5217C9.74983 14.6258 9.8978 14.7708 9.9996 14.9567C10.1026 15.1413 10.1541 15.3544 10.1541 15.5959C10.1541 15.8374 10.102 16.0504 9.99782 16.2351C9.89365 16.4198 9.74273 16.5636 9.54505 16.6666C9.34856 16.7695 9.11063 16.821 8.83127 16.821H7.91686V16.2049H8.70698C8.85495 16.2049 8.97687 16.1795 9.07275 16.1286C9.16981 16.0765 9.24202 16.0049 9.28937 15.9137C9.3379 15.8214 9.36217 15.7154 9.36217 15.5959C9.36217 15.4752 9.3379 15.3698 9.28937 15.2798C9.24202 15.1887 9.16981 15.1183 9.07275 15.0685C8.97569 15.0176 8.85258 14.9922 8.70343 14.9922H8.18497V18H7.41615Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9425 18H10.6535V14.3636H11.9532C12.3189 14.3636 12.6338 14.4364 12.8978 14.582C13.1617 14.7265 13.3647 14.9342 13.5068 15.2053C13.65 15.4763 13.7216 15.8007 13.7216 16.1783C13.7216 16.5571 13.65 16.8826 13.5068 17.1548C13.3647 17.4271 13.1606 17.636 12.8942 17.7816C12.6291 17.9272 12.3118 18 11.9425 18ZM11.4223 17.3413H11.9106C12.1378 17.3413 12.329 17.301 12.4841 17.2205C12.6403 17.1389 12.7575 17.0128 12.8356 16.8423C12.9149 16.6707 12.9546 16.4493 12.9546 16.1783C12.9546 15.9096 12.9149 15.69 12.8356 15.5195C12.7575 15.3491 12.6409 15.2236 12.4858 15.1431C12.3308 15.0626 12.1396 15.0224 11.9123 15.0224H11.4223V17.3413Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2911 18V14.3636H16.6988V14.9975H15.06V15.864H16.539V16.4979H15.06V18H14.2911Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/IconPDF.594a4805.svg";
export { ForwardRef as ReactComponent };